import { useEffect, useState } from 'react';

import { useCommonStore } from '@/store';

export function usePopupAfterRegSlide() {
  const regBannerActionBtnRect = useCommonStore.use.regBannerActionBtnRect();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const [hidePopup, setHidePopup] = useState(true);

  useEffect(() => {
    if (!isMobileDevice || regBannerActionBtnRect == null) setHidePopup(false);

    if (isMobileDevice && regBannerActionBtnRect != null) {
      const checkAdditionalSignUpVisible = () => {
        setHidePopup(regBannerActionBtnRect.top >= 0);
      };

      checkAdditionalSignUpVisible();
      window.addEventListener('scroll', checkAdditionalSignUpVisible);

      return () =>
        window.removeEventListener('scroll', checkAdditionalSignUpVisible);
    }
  }, [isMobileDevice, regBannerActionBtnRect, hidePopup, setHidePopup]);

  return { hidePopup };
}
